<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        },
        accommodation: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            toggled: false
        }
    }
}
</script>
<template>
    <div :class="{'account-activity-item__control--toggled': toggled}" class="account-activity-item">
        <div class="account-activity-item__header">
            <div class="account-activity-item__label">
                {{ date | moment("DD/MM/Y\, HH:mm") }}
            </div>
            <div class="account-activity-item__control" @click="toggled = !toggled">
                <i class="fa fa-fw fa-info"/>
            </div>
        </div>
        <transition name="account-activity-item__content-animation">
            <div v-if="toggled" class="account-activity-item__content">
                <div class="account-activity-item__props">
                    <div class="account-activity-item__prop">
                        <div class="account-activity-item__prop-key">
                            {{ $t('account.activity.type.label') }}
                        </div>
                        <div class="account-activity-item__prop-value">
                            {{ $t('account.activity.type.' + type) }}
                        </div>
                    </div>
                    <div class="account-activity-item__prop">
                        <div class="account-activity-item__prop-key">
                            {{ $t('account.activity.accommodation') }}
                        </div>
                        <div class="account-activity-item__prop-value">
                            {{ accommodation }}
                        </div>
                    </div>
                    <div class="account-activity-item__prop">
                        <div class="account-activity-item__prop-key">
                            {{ $t('account.activity.site') }}
                        </div>
                        <div class="account-activity-item__prop-value">
                            {{ site }}
                        </div>
                    </div>
                    <div class="account-activity-item__prop">
                        <div class="account-activity-item__prop-key">
                            {{ $t('account.activity.status.label') }}
                        </div>
                        <div class="account-activity-item__prop-value">
                            {{ $t('account.activity.status.' + status) }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AccountActivityItem/AccountActivityItem.vue